import React from 'react';
import { Loader2 } from 'lucide-react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'glass' | 'outline';
  isLoading?: boolean;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  isLoading = false, 
  className = '', 
  children, 
  disabled,
  ...props 
}) => {
  const baseStyles = "relative inline-flex items-center justify-center px-8 py-3.5 font-bold uppercase tracking-[0.15em] text-[10px] transition-all duration-300 rounded-none overflow-hidden disabled:opacity-50 disabled:cursor-not-allowed group active:scale-95";
  
  const variants = {
    primary: "bg-primary text-black hover:bg-white shadow-[0_0_20px_rgba(34,211,238,0.3)] hover:shadow-[0_0_40px_rgba(34,211,238,0.6)]",
    secondary: "bg-secondary text-black hover:bg-white shadow-[0_0_20px_rgba(74,222,128,0.3)] hover:shadow-[0_0_40px_rgba(74,222,128,0.6)]",
    ghost: "bg-transparent text-primary hover:bg-primary/10",
    glass: "bg-white/5 backdrop-blur-xl border border-white/10 text-white hover:bg-white/10",
    outline: "bg-transparent border border-primary/40 text-primary hover:bg-primary hover:text-black shadow-none",
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${className}`}
      disabled={isLoading || disabled}
      {...props}
    >
      {/* Decorative Corner Accents */}
      <span className="absolute top-0 left-0 w-1 h-1 bg-white opacity-40"></span>
      <span className="absolute bottom-0 right-0 w-1 h-1 bg-white opacity-40"></span>
      
      <span className="relative z-10 flex items-center">
        {isLoading && <Loader2 className="w-3 h-3 mr-2 animate-spin" />}
        {children}
      </span>
      
      {/* Hover Shimmer */}
      <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></span>
    </button>
  );
};